import { createApp } from 'vue'
import App from './App.vue'
import { initTracking } from './utils/tracking'

const app = createApp(App)

app.mount('#app')

initTracking({
	endpoint: process.env.VUE_APP_TRACKING_WORKER_URL || ''
})
